import { DaysOffRequestParams } from '../types/DaysOffRequestParams';
import { DaysOffUrlParamNames } from '../types/DaysOffUrlParams';

export const mapUrlParamsToRequestParams = (
  urlParamsNames: DaysOffUrlParamNames,
  searchParams: URLSearchParams,
): Partial<DaysOffRequestParams> => {
  const { pageParamName, yearParamName, sortByStartDateParamName } = urlParamsNames;

  const page = +(searchParams.get(pageParamName) || '');
  const year = +(searchParams.get(yearParamName) || '');
  const sortByDate = +(searchParams.get(sortByStartDateParamName) || '');

  return {
    ...(page && { page }),
    ...(year && { filter: { year } }),
    sort: { startDate: sortByDate },
  };
};
